import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { FF2, TextInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { useSubjectInformationItemContext } from '../SubjectInformationItemContext'

export const EntityNameOrLastName = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()
  const isEntity = useWatch({ control, name: `subjectsInfo.${index as 0}.isEntity` })
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()

  return (
    <Controller
      name={isEntity ? `subjectsInfo.${index as 0}.entityName` : `subjectsInfo.${index as 0}.lastName`}
      key={isEntity ? 'entityName' : 'lastName'}
      control={control}
      rules={{
        validate: (value) => (isAllInfoUnavailable ? undefined : Validators.required.field(value))
      }}
      render={({ field }) => (
        <FF2
          required={!isAllInfoUnavailable}
          field={field}
          label="4. Individual's last name or entity's legal name"
          input={(props) => (
            <TextInput
              {...props}
              data-qa="4. Individual's last name or entity's legal name"
              disabled={isAllInfoUnavailable}
            />
          )}
        />
      )}
    />
  )
}
